import React from 'react'

export default function ReturnsUnlabelledSwitch({
  retailer,
  unlabelledLockerValue,
  setUnlabelledLocker}) {
  return (
    <div className="parcel-details__print-in-store-option">
        {<div className="parcel-details__print-in-store-checkbox-container">
            <label className="checkbox-label">{`${!unlabelledLockerValue ? "Print at home" : "Unlabelled" }`}</label>
            {retailer?.unlabelledInpostLockers && retailer?.labelledInpostLockers && (
              <a onClick={(e) => {
                  e.preventDefault();
                  setUnlabelledLocker(!unlabelledLockerValue);
               }}
               href="">
                {`${unlabelledLockerValue ? "Print at home" : "Unlabelled"}`}
              </a>
            )}
        </div>}
    </div>

  )
}
